import React, { useState, useEffect, ReactNode, Children } from "react";

interface FadeInImagesProps {
    isTypingDone: boolean;
    children: ReactNode;
}

const FadeInImages: React.FC<FadeInImagesProps> = ({ isTypingDone, children }) => {
    const [showCerts, setShowCerts] = useState(false);

    useEffect(() => {
        if (isTypingDone) {
            const timer = setTimeout(() => setShowCerts(true), 6000);
            return () => clearTimeout(timer);
        }
    }, [isTypingDone]);

    return (
        <div className="flex flex-col md:flex-row justify-center items-center gap-6 md:gap-x-20">
            {Children.map(children, (child, index) => (
                <div
                    key={index}
                    style={{ transitionDelay: `${index * 2400}ms` }} 
                    className={`duration-1000 ease-in-out transition-all
                        ${showCerts ? "opacity-100 translate-y-0" : "opacity-0 translate-y-20"}
                    `}
                >
                    {child}
                </div>
            ))}
        </div>
    );
};

export default FadeInImages;